import { Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { openCookieSettings } from '../tools/cookieConsent';
import { img } from '../data/siteData';
import FooterInquiry from './FooterInquiry';

function Footer() {
  return (
    <>
    <FooterInquiry />
    <footer>
      <div>
        <img src={img('logos/CM_BALING_NEW_LOGO.png')} alt="C+M Baling Systems" />
        <p>Industrial baling equipment for commercial, recycling, textile, paper, and manufacturing applications.</p>
      </div>
      <div>
        <b>Keep in touch</b>
        <a href="tel:8002253796"><Phone size={16} />(800) 225-3796</a>
        <a href="mailto:sales@baling.com"><Mail size={16} />sales@baling.com</a>
      </div>
      <div>
        <b>Explore</b>
        <Link to="/products">Products</Link>
        <Link to="/baler-selection-guide">Selection Guide</Link>
        <Link to="/service-department">Parts & Service</Link>
      </div>
      <div className="footer-bottom">
        <small>&copy; {new Date().getFullYear()} C+M Baling Systems, Inc.</small>
        <nav className="footer-privacy-links" aria-label="Privacy and cookie settings">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span aria-hidden="true">|</span>
          <button type="button" className="cookie-settings-link" onClick={openCookieSettings}>Cookie settings</button>
        </nav>
        <p className="recaptcha-disclosure">This site is protected by reCAPTCHA.</p>
      </div>
    </footer>
    </>
  );
}

export default Footer;
